import { motion } from "framer-motion";
import type { CSSProperties } from "react";

interface MaskedSlideRevealProps {
  text: string;
  className?: string;
  wordClassName?: string;
  gradientClassName?: string;
  style?: CSSProperties;
  staggerDelay?: number;
  as?: "p" | "span" | "h1" | "h2" | "h3" | "h4";
}

export function MaskedSlideReveal({
  text,
  className,
  wordClassName,
  gradientClassName,
  style,
  staggerDelay = 0.08,
  as: Tag = "p",
}: MaskedSlideRevealProps) {
  if (gradientClassName) {
    return (
      <Tag className={className} style={style}>
        <span className="inline-block overflow-hidden align-bottom leading-[1.7] pb-[0.3em]">
          <motion.span
            className={gradientClassName}
            style={{
              display: "inline-block",
              willChange: "transform",
              lineHeight: 1.35,
              paddingBottom: "0.12em",
            }}
            initial={{ y: "100%" }}
            animate={{ y: "0%" }}
            transition={{
              type: "spring",
              damping: 14,
              stiffness: 120,
            }}
          >
            {text}
          </motion.span>
        </span>
      </Tag>
    );
  }

  const words = text.split(" ");
  const content = words.map((word, i) => (
    <span
      key={i}
      style={{
        display: "inline-block",
        overflow: "hidden",
        verticalAlign: "bottom",
        lineHeight: 1.15,
        marginRight: "0.25em",
      }}
    >
      <motion.span
        className={wordClassName}
        style={{ display: "inline-block", willChange: "transform" }}
        initial={{ y: "100%" }}
        animate={{ y: "0%" }}
        transition={{
          type: "spring",
          damping: 14,
          stiffness: 120,
          delay: i * staggerDelay,
        }}
      >
        {word}
      </motion.span>
    </span>
  ));

  return (
    <Tag className={className} style={style}>
      {content}
    </Tag>
  );
}
